export default __webpack_public_path__ + "static/media/logo.8627a0b3.png";